import Note from '@/components/Note';
import IconV2 from '@/components/v2/IconV2.jsx';
import { FiInfo } from '@/components/react-icons/main';
import OutputObjects from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/outputPanel/OutputObject';
import getFlowControlEmailRateLimitNotice from '../../lib/getFlowControlEmailRateLimitNotice';
import getParallelLoopNotice from '../../lib/getParallelLoopNotice';

// `rows` is the page of `response.data` to render; the full response stays available for notices.
// The server-truncation card follows the final row, so it renders only on the last page. Cards stay
// unnumbered: passing `numberingStartIndex` would make `CardOutput` number the truncation card.

const SummarySection = ({ response, rows, isLastPage, search }) => {
  const rateLimitNotice = getFlowControlEmailRateLimitNotice(response?.data);
  const parallelNotice = getParallelLoopNotice(response);
  const outputMeta = response?.meta?.output;
  const difference = outputMeta?.total - outputMeta?.limit;
  const moreMessage = `${difference} more record${difference === 1 ? '' : 's'}`;

  const limited = outputMeta?.limit && outputMeta?.total && outputMeta?.limit < outputMeta?.total;
  const showLimitObject = limited && isLastPage;

  const limitObject = {
    __meta: {
      presentation: {
        type: 'card',
        className: 'more-records',
        fields: {
          id: '',
          name: moreMessage,
          description: `(Data limited for performance)`
        }
      }
    }
  };

  const finalData = Array.isArray(rows) ? [...rows, ...(showLimitObject ? [limitObject] : [])] : rows;

  return (
    <>
      {parallelNotice && (
        <Note
          type={parallelNotice.type}
          size="sm"
          text={
            <>
              {parallelNotice.text} {parallelNotice.tooltip && <IconV2 icon={FiInfo} size="sm" title={parallelNotice.tooltip} />}
            </>
          }
        />
      )}
      {rateLimitNotice && (
        <Note
          type="warning"
          size="sm"
          text={
            <>
              {rateLimitNotice.text} <IconV2 icon={FiInfo} size="sm" title={rateLimitNotice.tooltip} />
            </>
          }
        />
      )}
      <OutputObjects search={search} output={finalData} />
    </>
  );
};

export default SummarySection;
